var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCombined = function SvgCombined(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 120,
    viewBox: "0 0 205 120",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(-17 -7)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Tropical_Cyclone_Platform",
    "data-name": "Tropical  Cyclone  Platform",
    transform: "translate(120 24)",
    fill: "#233d43",
    fontSize: 24,
    fontFamily: "Lato-Black, Lato",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "Tropical "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 53
  }, "Cyclone "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 82
  }, "Platform")), /*#__PURE__*/React.createElement("g", {
    id: "cyclone_black_24dp",
    transform: "translate(17 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 108,
    height: 108,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(9.041 9.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M26.082,8A18.082,18.082,0,1,0,44.164,26.082,18.077,18.077,0,0,0,26.082,8Zm0,27.123a9.041,9.041,0,1,1,9.041-9.041A9.068,9.068,0,0,1,26.082,35.123Z",
    transform: "translate(19.123 19.123)",
    fill: "#233d43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M92.41,26.727V17.144a161.12,161.12,0,0,0-45.205-6.1A36.033,36.033,0,0,0,22.161,21.167,116.616,116.616,0,0,1,26.727,2H17.144a161.12,161.12,0,0,0-6.1,45.205A36.033,36.033,0,0,0,21.167,72.249,121.6,121.6,0,0,1,2,67.683v9.583a161.121,161.121,0,0,0,45.205,6.1A36.033,36.033,0,0,0,72.249,73.243,121.6,121.6,0,0,1,67.683,92.41h9.583a161.121,161.121,0,0,0,6.1-45.205A36.033,36.033,0,0,0,73.243,22.161,116.615,116.615,0,0,1,92.41,26.727Zm-45.205,47.6A27.123,27.123,0,1,1,74.328,47.205,27.145,27.145,0,0,1,47.205,74.328Z",
    transform: "translate(-2 -2)",
    fill: "#233d43"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCombined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/combined.2d55db27.svg";
export { ForwardRef as ReactComponent };